import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import placeholderAvatar from 'assets/images/user_placeholder.png'
import { Button } from 'components/Button/Button'


import './_unsubscribe-modal.scss'

interface UnsubscribeProfileModalProps {
    avatar: string | null
    displayName: string
    username: string
    subscribeFn: any
    setOpen: any
    isLoading?: boolean
    rebill?: boolean | number
    updated_at?: any
    expiry_at?: any
}

const UnsubscribeProfileModal = ({
    avatar,
    displayName,
    username,
    subscribeFn,
    setOpen,
    rebill,
    expiry_at
}: UnsubscribeProfileModalProps) => {
    const [showReason, setShowReason] = useState(false)
    const [reason, setReason] = useState('')
    const { t } = useTranslation()

    let updatedDate = ''
    if (expiry_at) {
        updatedDate = new Intl.DateTimeFormat('en-US', {
            month: 'long',
            day: '2-digit',
            year: 'numeric'
        }).format(new Date(expiry_at))
    }

    // fallback image handler
    const handleImgError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        e.currentTarget.src = placeholderAvatar
    }

    return (
        rebill === 1 ? (
            <div className='unsubscribe-modal-wrapper'>
                <div className='unsubscribe-modal-title'>{t('subscription')}</div>

                <div className='unsubscribe-modal-user-info-container'>
                    <div className='unsubscribe-modal-profile-pic-container'>
                        <img
                            src={avatar ?? placeholderAvatar}
                            onError={handleImgError}
                            alt={t('profileAvatar')}
                        />
                    </div>
                    <div className='unsubscribe-modal-user-info'>
                        <div className='unsubscribe-modal-user-info-name'>{displayName}</div>
                        <div className='unsubscribe-modal-user-info-username'>@{username}</div>
                    </div>
                </div>

                <div className='unsubscribe-modal-description'>
                    {t('ifYouUnsubscribe')} {updatedDate}
                </div>

                <div
                    className='unsubscribe-modal-reason-text'
                    onClick={() => setShowReason(!showReason)}
                >
                    {t('addReason')}
                </div>

                <div
                    className={`unsubscribe-modal-reason-input-wrapper ${
                        showReason ? 'unsubscribe-modal-reason-input-wrapper-open' : ''
                    }`}
                >
                    <textarea
                        className='unsubscribe-modal-reason-input'
                        rows={5}
                        value={reason}
                        onChange={e => setReason(e.target.value)}
                    />
                </div>

                <div className='unsubscribe-modal-buttons'>
                    <Button
                        text={t('back')}
                        color='grey'
                        font='mont-14-normal'
                        height='4'
                        width='10'
                        clickFn={() => setOpen(false)}
                    />
                    <Button
                        text={t('unsubscribe')}
                        color='black'
                        font='mont-14-normal'
                        height='4'
                        width='14'
                        clickFn={subscribeFn}
                    />
                </div>
            </div>
        ) : (
            <div className='unsubscribe-modal-wrapper'>
                <div className='unsubscribe-modal-title'>{t('Renew Subscription')}</div>

                <div className='unsubscribe-modal-user-info-container'>
                    <div className='unsubscribe-modal-profile-pic-container'>
                        <img
                            src={avatar ?? placeholderAvatar}
                            onError={handleImgError}
                            alt={t('profileAvatar')}
                        />
                    </div>
                    <div className='unsubscribe-modal-user-info'>
                        <div className='unsubscribe-modal-user-info-name'>{displayName}</div>
                        <div className='unsubscribe-modal-user-info-username'>@{username}</div>
                    </div>
                </div>

                <div style={{ paddingBottom: '2rem' }} className='unsubscribe-modal-description'>
                    {t(
                        'If you renew your subscription your subscription will automatically renew on its original renewal date, '
                    )}{' '}
                    {updatedDate}.
                </div>

                <div className='unsubscribe-modal-buttons'>
                    <Button
                        text={t('close')}
                        color='grey'
                        font='mont-14-normal'
                        height='4'
                        width='10'
                        clickFn={() => setOpen(false)}
                    />
                    <Button
                        text={t('Stay Subscribed')}
                        color='black'
                        font='mont-14-normal'
                        height='4'
                        width='16'
                        clickFn={subscribeFn}
                    />
                </div>
            </div>
        )
    )
}

export default UnsubscribeProfileModal
